<div class="dialog-container">
  <h1 mat-dialog-title>Organisationen importieren</h1>

  <div mat-dialog-content>
    <!-- STEP 1: UPLOAD -->
    <div *ngIf="step === 'UPLOAD'">
      <div class="upload-area" (click)="fileInput.click()">
        <p>CSV-Datei hierher ziehen oder klicken zum Auswählen</p>
        <input #fileInput type="file" (change)="onFileSelected($event)" accept=".csv" style="display: none">
      </div>
      <div class="options-area" style="margin-top: 15px;">
        <mat-form-field appearance="outline">
          <mat-label>Trennzeichen</mat-label>
          <mat-select [(ngModel)]="delimiter" (selectionChange)="onDelimiterChange()">
            <mat-option *ngFor="let d of availableDelimiters" [value]="d.value">
              {{d.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- STEP 2: MAPPING -->
    <div *ngIf="step === 'MAPPING'">
      <div class="mapping-options" style="margin-bottom: 15px;">
        <mat-form-field appearance="outline">
          <mat-label>Trennzeichen ändern</mat-label>
          <mat-select [(ngModel)]="delimiter" (selectionChange)="onDelimiterChange()">
            <mat-option *ngFor="let d of availableDelimiters" [value]="d.value">
              {{d.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <p>Bitte ordnen Sie die CSV-Spalten den Organisations-Feldern zu:</p>
      <table class="mapping-table">
        <thead>
          <tr>
            <th>Zielfeld</th>
            <th>CSV-Spalte</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let field of targetFields">
            <td>{{field.label}} <span *ngIf="field.required">*</span></td>
            <td>
              <mat-form-field appearance="outline">
                <mat-select [(ngModel)]="fieldMappings[field.key]">
                  <mat-option [value]="null">Nicht zugeordnet</mat-option>
                  <mat-option *ngFor="let header of csvHeaders" [value]="header">{{header}}</mat-option>
                </mat-select>
              </mat-form-field>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="actions">
        <button mat-raised-button color="primary" (click)="applyMapping()">Vorschau</button>
      </div>
    </div>

    <!-- STEP 3: REVIEW -->
    <div *ngIf="step === 'REVIEW'">
      <div *ngIf="hasConflicts" class="conflict-warning">
        <span>⚠️ Einige Organisationen existieren bereits. Möchten Sie diese überschreiben oder überspringen?</span>
        <div class="bulk-actions">
          <button mat-button color="warn" (click)="skipAllConflicts()">Alle Konflikte überspringen</button>
          <button mat-button color="accent" (click)="overwriteAllConflicts()">Alle Konflikte überschreiben</button>
        </div>
      </div>

      <p>Überprüfen Sie die importierten Daten:</p>
      <div class="table-container">
        <table class="preview-table">
          <thead>
            <tr>
              <th><mat-checkbox (change)="toggleAll($event)"></mat-checkbox></th>
              <th>Name</th>
              <th>Typ</th>
              <th *ngFor="let field of targetFields.slice(1)">{{field.label}}</th>
              <th>Status</th>
              <th>Aktion</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of importRows">
              <td><mat-checkbox [(ngModel)]="row.selected"></mat-checkbox></td>
              <td>{{row.organisation.organisationName}}</td>
              <td>
                <mat-select [(ngModel)]="row.organisation.organisationType" multiple
                  style="border: 1px solid var(--app-outline); padding: 2px; width: 100%;">
                  <mat-option *ngFor="let type of organisationTypes" [value]="type">
                    {{type}}
                  </mat-option>
                </mat-select>
              </td>
              <td>{{row.organisation.description}}</td>
              <td>{{row.organisation.website}}</td>
              <td>{{row.organisation.address?.street}}</td>
              <td>{{row.organisation.address?.city}}</td>
              <td>{{row.organisation.address?.postalCode}}</td>
              <td>{{row.organisation.phoneNumber}}</td>
              <td>
                <span [class.status-success]="row.status === 'SUCCESS'" [class.status-failed]="row.status === 'FAILED'"
                  [class.status-conflict]="row.status === 'CONFLICT'"
                  [class.status-rejected]="row.status === 'REJECTED'">
                  {{row.status === 'CONFLICT' ? 'EXISTIERT BEREITS' : row.status}}
                  <span *ngIf="row.error" [title]="row.error">ℹ️</span>
                </span>
              </td>
              <td>
                <div *ngIf="row.status === 'PENDING'">
                  <button mat-icon-button (click)="acceptRow(row)" title="Importieren">✅</button>
                  <button mat-icon-button (click)="skipRow(row)" title="Überspringen">❌</button>
                </div>
                <div *ngIf="row.status === 'CONFLICT'">
                  <button mat-icon-button (click)="overwriteRow(row)" title="Überschreiben">🔄</button>
                  <button mat-icon-button (click)="skipRow(row)" title="Überspringen">❌</button>
                </div>
                <button mat-icon-button *ngIf="row.status === 'FAILED'"
                  (click)="row.isConflict ? overwriteRow(row) : acceptRow(row)" title="Erneut versuchen">🔄</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div mat-dialog-actions align="end">
    <div *ngIf="step === 'REVIEW'" class="bulk-actions">
      <button mat-button color="accent" *ngIf="importedIds.length > 0" (click)="undoImport()"
        [disabled]="isProcessing">Rückgängig ({{importedIds.length}})</button>
      <button mat-button color="warn" (click)="rejectAll()" [disabled]="isProcessing">Alle ablehnen</button>
      <button mat-button color="primary" (click)="acceptSelected()" [disabled]="isProcessing">Ausgewählte
        akzeptieren</button>
      <button mat-raised-button color="primary" (click)="acceptAll()" [disabled]="isProcessing">Alle
        akzeptieren</button>
    </div>
    <button mat-button (click)="onClose()" [disabled]="isProcessing">Schließen</button>
  </div>
</div>